import { Injectable } from '@angular/core';
import { GeneralHttpService } from '../general-http.service';

@Injectable({
  providedIn: 'root'
})
export class AuthorizeService {
  private readonly routeApi = "Login";

  constructor(
    private _generalHttp: GeneralHttpService
  ) { }

  getTerminosYCondiciones(){
    return this._generalHttp.postWithoutToken(null,`${this.routeApi}/GetTerminosYCondiciones`);
  }

  insertPersonJuridica(form:any){
    return this._generalHttp.postHttp(form,`${this.routeApi}/InsertPersonJuridica`)
  }

  insertAdministradorDesignado(form:any){
    return this._generalHttp.postHttp(form,`${this.routeApi}/InsertAdministradorDesignado`)
  }


  insertPersonNatural(form:any){
    return this._generalHttp.postHttp(form,`${this.routeApi}/InsertPersonaNatural`);
  }

  recoveryPass(form:any){
    return this._generalHttp.postHttp(form,`${this.routeApi}/RecoveryPass`);
  }

  changePassword(form: any) {
    return this._generalHttp.postHttp(form, `${this.routeApi}/ChangePassword`);
  }

  registerPassword(form: any) {
    return this._generalHttp.postHttp(form, `${this.routeApi}/RegisterPassword`);
  }

  validateToken(token: string) {
    return this._generalHttp.getHttpById(token, `${this.routeApi}/ValidateToken`);
  }

  validateTokenRegisterPerson(token:string){
    return this._generalHttp.getHttpById(token,`${this.routeApi}/ValidateTokenRegisterPerson`);
  }

  sendTokenForgotPass(form:any){
    return this._generalHttp.postHttp(form,`${this.routeApi}/SendTokenForgotPass`);
  }

  validateTokenSeguridad(form: any) {
    return this._generalHttp.postHttp(form, `${this.routeApi}/AuthorizeUrl`);
  }

  validateTokenIdentity(token:string){
    return this._generalHttp.getHttpById(token, `${this.routeApi}/ValidateTokenIdentity`);
  }

  sendTokenNumberValidate(token:string){
    return this._generalHttp.getHttpById(token, `${this.routeApi}/SendTokenNumberValidate`);
  }

  validateCodeOtp(data:any){
    return this._generalHttp.postHttp(data, `${this.routeApi}/ValidateCodeOtp`);
  }

  validarRespuestas(data:any){
    return this._generalHttp.postHttp(data, `${this.routeApi}/ValidarRespuestas`);
  }

  generarPreguntas(data:any){
    return this._generalHttp.postHttp(data, `${this.routeApi}/GenerarPreguntas`);
  }
  

  logOut(form: any) {
    return this._generalHttp.postHttp(form, `${this.routeApi}/LogOut`);
  }

}
